const filterNodes = {
  quickShopModal: document.querySelector('quick-shop'),
  parent: document.getElementById('collectionFilters'),
  gridsContainer: document.getElementById('products-listing'),
  activeFilters: document.querySelector('[data-activeFilters]'),
  drawerFooter: document.querySelector('[data-filterFooter]'),
  openDrawerBtns: document.querySelectorAll('[data-openFilterDrawer]'),
  paginationParent: document.querySelector('[data-paginationParent]'),
  closeDrawer: document.querySelector('[data-closeDrawer]'),
  filterDrawerTrigger: document.querySelector('[data-openfilterdrawer]')
}

class CollectionFilters {
  constructor() {
    this.filterForm = filterNodes.parent.querySelector('form');

    filterNodes.parent.addEventListener('keyup', (event) => {
      if(event.code && event.code.toUpperCase() === 'ESCAPE') filterNodes.closeDrawer.dispatchEvent(new Event('click'));
    });

    this.debouncedOnSubmit = Utility.debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    if(this.filterForm){
      this.filterForm.addEventListener('input', (evt)=>{
        if((evt && evt.target.type == 'range') || window.innerWidth < 992) return false;
        this.debouncedOnSubmit(evt);
      });
      this.filterForm.addEventListener('submit', this.debouncedOnSubmit.bind(this));
     
      window.addEventListener('popstate', this.onHistoryChange.bind(this));
    }
    
    this.bindEvents();
    this.dynamicEleEvents();
  }

  /**
   * bind dclick and keyup event to Cart Icons
   * bind keyUp event to Cart drawer component
   * bind Other inside element events
   *
  */
  bindEvents() {
    /** There are two open drawer buttons, one for Open filter drawer other for open sortby drawer **/
    if(filterNodes.openDrawerBtns.length > 0){
      filterNodes.openDrawerBtns.forEach(button => button.addEventListener('click', this.toggleFilterDrawer.bind(this)));
    }
    filterNodes.closeDrawer.addEventListener('click', this.toggleFilterDrawer.bind(this));

    let sortby_desktop = document.querySelectorAll('[data-sortByDesktop] .sortby_options');
    sortby_desktop.forEach(input => input.addEventListener('change', this.updateSortBy.bind(this)));
  }

  dynamicEleEvents() {
    if(filterNodes.quickShopModal && typeof filterNodes.quickShopModal.updateEvents == 'function'){ 
      filterNodes.quickShopModal.updateEvents(); 
    }

    filterNodes.parent.querySelectorAll('[data-backfilterblock]').forEach(button => 
      button.addEventListener('click', (evt)=>{
        evt.preventDefault();
        let parent = evt.currentTarget.closest('[is="collapsiblePanel"]');
        let filterBlock = parent.querySelector('.filter__block.toggle-content');
        if(filterBlock.classList.contains('open')) parent.querySelector('.panel_toggle').click();
      })
    );

    const applyBtn = filterNodes.parent.querySelector('[data-applyFilters]');
    if(applyBtn){
      applyBtn.addEventListener('click', () => {
        const searchParams = this._createQueryString(this.filterForm)
        this.renderPage(searchParams);
      });
    }

    const paginationLinks = document.querySelectorAll('[data-pagelinks]');
    paginationLinks.forEach(link => link.addEventListener('click', this._managePagination.bind(this)));

    this.colorOptionsStyling();
    this.bindActiveFilterButtonEvents();
  }

  /**
   * Collection filter form Input event
   * @param {event} event Event Instance
   */
  onSubmitHandler(event) {
    event.preventDefault();
    const searchParams = this._createQueryString(this.filterForm);
    this.renderPage(searchParams);
  }

  /**
   * click event To Remove current selections
   * @param {element} form Collection page filter form
   */
  _createQueryString(form){
    const formData = new FormData(form);
    if(form.querySelector('[name="filter.v.price.gte"]')){
      const priceGTE = form.querySelector('[name="filter.v.price.gte"]').min;
      const priceLTE = form.querySelector('[name="filter.v.price.lte"]').max;

      if(parseInt(formData.get('filter.v.price.gte')) == parseInt(priceGTE)){
        formData.delete('filter.v.price.gte');
      }
      if(parseInt(formData.get('filter.v.price.lte')) == parseInt(priceLTE)){
        formData.delete('filter.v.price.lte');
      }
    }
    // bypass minmun value of age filter
    if(form.querySelector('[name="filter.p.m.custom.recommended_age"]')){
      let ageMinValue = form.querySelector('#age-lte-input');
      let recommendedAgeValues = formData.get('filter.p.m.custom.recommended_age');
      if(recommendedAgeValues.includes(ageMinValue.min) && recommendedAgeValues.includes(ageMinValue.max)){
        formData.delete('filter.p.m.custom.recommended_age');
      }
    }

    return decodeURIComponent(new URLSearchParams(Array.from(formData)).toString());
  }

  /**
   * 
   * @param {String} searchParams Query Parameters
   * @param {String} updateURLHash true/false
  */
  renderPage(searchParams, updateURLHash = true) {
    filterNodes.gridsContainer.classList.add('loading');

    const url = `${window.location.pathname}?${searchParams}`;
    this.renderGridFromFetch(url);

    if (updateURLHash) this.updateURLHash(searchParams);
  }

  /**
   * Add background color in label of Color options
   */
  colorOptionsStyling(){
    const colorSwatchContainer = filterNodes.parent.querySelector('[data-colorFilter]');
    if(colorSwatchContainer){
      const colorSwatches = colorSwatchContainer.querySelectorAll('.color-options');
      colorSwatches.forEach(swatch => {
        let colorHandle = swatch.querySelector('input[type="checkbox"]').dataset.handle;
        let swatchStyle = Utility.getSwatchStyle(colorHandle);
        swatch.querySelector('.option-label').setAttribute('style', swatchStyle);
      });
    }
  }

  /**
   * click event To Remove current selections
   * @param {event} event Event Instance
   */
   onActiveFilterClick(event) {
    event.preventDefault();
    event.stopImmediatePropagation();

    const urlParams =  new URL(event.currentTarget.href).searchParams;
    // Logic to combine seprate filter.p.m.custom.recommended_age filter value in one key
    const combinedParams = {};
    for (const [key, value] of urlParams.entries()) {
      if (combinedParams[key]) {
        combinedParams[key] += `,${value}`;
      } else {
        combinedParams[key] = value;
      }
    }

    let searchParams = new URLSearchParams(combinedParams);
    if(event.currentTarget.classList.contains('for-age-range')){
      searchParams.delete('filter.p.m.custom.recommended_age');
    }

    let URLString = decodeURIComponent(searchParams).toString();
    if(URLString != null) this.renderPage(URLString);
  }

   /**
   * Update Window URL as per active filters
   * @param {event} event Event Instance
   */
  onHistoryChange(event) {
    const searchParams = event.state?.searchParams || '';
    this.renderPage(searchParams, false);
  }

  /**
   * 
   * @param {String} url URL for fetching results
   * @param {String} type Type pagination or filter
   */
  renderGridFromFetch(url, type) {
    if(!url) return;

    let sectionID = document.getElementById('products-listing').dataset.id;
    url += `&sections=${sectionID}`;
   
    fetch(url)
    .then(response => response.json())
    .then((response) => {
      let gridHTML = response[sectionID];
      this.renderProductGrid(gridHTML);
    });
    if (type == 'pagination') {
      filterNodes?.gridsContainer?.scrollIntoView({'behavior': 'smooth'})
    }
  }

  /**
   * 
   * @param {HTMlResponse} html 
   */
  renderProductGrid(grid) {
    const collectionParent = new DOMParser().parseFromString(grid, 'text/html');
    const gridsHTML = collectionParent.getElementById('products-listing').innerHTML;
    filterNodes.gridsContainer.innerHTML = gridsHTML;
  
    const filterPanels = collectionParent.querySelectorAll('#CollectionFiltersForm .filter__container');
    document.querySelectorAll('#CollectionFiltersForm .filter__container').forEach(panel => panel.classList.add('d-none'));
    filterPanels.forEach((panel)=> {
      let filterBlock = document.querySelector('.filter__container[data-index="'+panel.dataset.index+'"]');
      if(filterBlock){
        filterBlock.querySelector('.filter__block').innerHTML = panel.querySelector('.filter__block').innerHTML;
        filterBlock.classList.remove('d-none');
      }
    });

    filterNodes.drawerFooter.innerHTML = collectionParent.querySelector('[data-filterFooter]').innerHTML;
    document.querySelector('[data-totalproducts]').innerHTML = collectionParent.querySelector('[data-totalproducts]').innerHTML;

    const filterDrawerTrigger = collectionParent.querySelector('[data-openfilterdrawer]');
    if(filterDrawerTrigger) filterNodes.filterDrawerTrigger.innerHTML = filterDrawerTrigger.innerHTML;

    const activeFilters = collectionParent.querySelector('[data-activeFilters]');
    if(activeFilters) filterNodes.activeFilters.innerHTML = activeFilters.innerHTML;
    this.dynamicEleEvents();

    let drawerOpen = filterNodes.parent.classList.contains('filter-active');
    if(drawerOpen) filterNodes.closeDrawer.dispatchEvent(new Event('click'));

    let closeDrawerSubChild = document.querySelectorAll('#collectionFilters .open [data-backfilterblock]');
    if (closeDrawerSubChild.length > 0) closeDrawerSubChild.forEach(subTrigger => subTrigger.click());
  }

  /**
   * Re-Binding events on active filters after ajax request
   */
  bindActiveFilterButtonEvents() {
    let removeActiveFilters = Array.from(document.getElementsByClassName('filter-option-clear'));
    removeActiveFilters.forEach((element) => {
      element.addEventListener('click', this.onActiveFilterClick.bind(this), { once: true });
    });
  }

  /**
   * Update the url
   * @param {String} searchParams 
   */
  updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  /**
   * 
   * @param {event} event 
   */
  updateSortBy(event){
    let currentEle = event.currentTarget;
    let targetOpt = this.filterForm.querySelector(`input[name="sort_by"][value="${currentEle.value}"]`);
    if(targetOpt){
      targetOpt.checked = true;
      this.filterForm.dispatchEvent(new Event('input', {
        once: true,
      }));
    }
  }

  /**
   * 
   * @param {event} event 
   */
  _managePagination(event){
    event.preventDefault();
    let _this = event.currentTarget;
    this.renderGridFromFetch(_this.href, 'pagination');

    let paginationType = _this.closest('[data-paginationparent]').dataset.type;
    if(paginationType != 'loadmore'){
      setTimeout(() => {
        history.pushState({}, '', _this.href);
      }, 500);
    }
  }

  /**
   * Toggle Filter drawer
   * @param {event} event 
   */
  toggleFilterDrawer(event){
    event.preventDefault();
    let button = event.currentTarget;
    if(button.id == 'filter-drawer' || button.id == 'sortby-drawer'){
      button.setAttribute('aria-expanded', true);
      button.setAttribute('tabindex', '-1');

      (button.id == 'sortby-drawer') ? (filterNodes.parent.classList.add('sortby-active')) : filterNodes.parent.classList.remove('sortby-active');
      filterNodes.parent.classList.add('filter-active');

      Utility.trapFocus(filterNodes.parent);
      Utility.forceFocus(filterNodes.closeDrawer);
      siteOverlay.prototype.showOverlay();
    }else{
      filterNodes.parent.classList.remove('filter-active', 'sortby-active');
      if(this.openFilterDrawer){
        this.openFilterDrawer.setAttribute('aria-expanded', false);
        this.openFilterDrawer.removeAttribute('tabindex');
      }
      if(this.openSortbyDrawer){
        this.openSortbyDrawer.setAttribute('aria-expanded', false);
        this.openSortbyDrawer.removeAttribute('tabindex');
      }

      Utility.removeTrapFocus(filterNodes.parent);
      siteOverlay.prototype.hideOverlay();
    }
  }
}
typeof CollectionFilters !== 'undefined' && new CollectionFilters();

class PriceRangeSlider extends HTMLElement {
  constructor() {
    super();

    let _this = this;
    let form = this.closest('form');
    let sliderSections = this.getElementsByClassName("range-slider");

    for(const element of sliderSections){
      let sliders = element.getElementsByTagName("input");
      for(const element of sliders){
        if(element.type === "range" ){
          element.oninput = _this.getVals;
          element.oninput();

          if(form && form.id == 'CollectionFiltersForm'){
            element.onchange = (_evt)=>{
              if(window.innerWidth >= 992) form.dispatchEvent(new CustomEvent('submit'));
            } 
          }
        }
      }
    }
  }
  
  // Get Price value from both range slider
  getVals(){
    let parent = this.parentNode;
    let slides = parent.getElementsByTagName("input");
    let slide1 = parseFloat(slides[0].value);
    let slide2 = parseFloat(slides[1].value);
      
    // Neither slider will clip the other, so make sure we determine which is larger
    if( slide1 > slide2 ){ let tmp = slide2; slide2 = slide1; slide1 = tmp; }
    
    let displayElement = parent.getElementsByClassName("rangeValues")[0];
    displayElement.innerHTML = Utility.formatMoney((slide1*100), `${window.globalVariables.money_format} - ${Utility.formatMoney((slide2*100), window.globalVariables.money_format)}`);
  }
}
customElements.define('price-range-slider', PriceRangeSlider);

class AgeRangeSlider extends HTMLElement {
  constructor() {
    super();

    let form = this.closest('form');
    this.rangeValue = '';
    let sliderSections = this.getElementsByClassName("age-range-sliders");

    for(const element of sliderSections){
      let sliders = element.getElementsByTagName("input");
      for(const element of sliders){
        if(element.type === "range" ){
          element.oninput = this.getVals.bind(this);
          element.oninput();

          if(form && form.id == 'CollectionFiltersForm'){
            element.onchange = (_evt)=>{
              this.querySelector('.age-range').value = this.rangeValue;
              if(window.innerWidth >= 992) form.dispatchEvent(new CustomEvent('submit'));
            } 
          }
        }
      }
    }
  }
  
  getVals(){
    let parent = this.querySelector('.age-range-sliders');
    let slides = parent.getElementsByTagName("input");
    let slide1 = parseFloat(slides[0].value);
    let slide2 = parseFloat(slides[1].value);
      
    // Neither slider will clip the other, so make sure we determine which is larger
    if( slide1 > slide2 ){ let tmp = slide2; slide2 = slide1; slide1 = tmp; }
    
    const ageRangeValues = [];
    for (let i=slide1; i <= slide2; i++) {
      ageRangeValues.push(i);
    }
    this.rangeValue = ageRangeValues.toString();
    this.querySelector('#age-lte-input').value = slide1;
    this.querySelector('#age-gte-input').value = slide2;
  }
}
customElements.define('age-range-slider', AgeRangeSlider);